/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summermusicfestival2Inputs */

const en_summermusicfestival2 = /** @type {(inputs: Summermusicfestival2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summer Music Festival`)
};

const de_summermusicfestival2 = /** @type {(inputs: Summermusicfestival2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommer-Musikfestival`)
};

/**
* | output |
* | --- |
* | "Summer Music Festival" |
*
* @param {Summermusicfestival2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summermusicfestival2 = /** @type {((inputs?: Summermusicfestival2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summermusicfestival2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summermusicfestival2(inputs)
	return de_summermusicfestival2(inputs)
});
export { summermusicfestival2 as "summerMusicFestival" }